import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../../../../../../../../shared/shared.module';
import { StepperContextService, StepperMode } from '../../../../../../services/stepper-context.service';
import { StepperAnswersService } from '../../../../../../services/stepper-answers.service';
import { StepperTasksService } from '../../../../../../services/stepper-tasks.service';
import { LgvTSHelper } from '../../../../../../../../core/core.module'
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'lgv-create-loan-success',
  standalone: true,
  imports: [CommonModule,
    FontAwesomeModule,
    MatDividerModule,
    MatButtonModule
  ],
  templateUrl: './create-loan-success.component.html',
  styleUrls: ['./create-loan-success.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateLoanSuccessComponent {

  isDialog = this.contextService.isDialog
  @Output() closeDialog = new EventEmitter<any>();

  constructor(
    public contextService: StepperContextService,
    public answerService: StepperAnswersService,
    public taskService: StepperTasksService,
    private router: Router,
  ) { }

  onClose() {
    this.answerService.clear()
    this.closeDialog.emit();
  }

  onContinue(): void {
    if (this.contextService.mode === StepperMode.AgentMode) {
      let url = LgvTSHelper.environmentBaseUrl + '#/token/ct/' + this.contextService.clientToken
      let newTab = window.open(url, '_blank');
      if (newTab) {
        newTab.focus();
      }
    } else {
      this.answerService.clear()
      this.closeDialog.emit();
      this.router.navigate([`/client/loan-app/${this.contextService.loanId}/tasks`]);
    }
  }
}
